import { useWalletDetails } from "@sundae/wallet-react";
import { useQuery } from "@tanstack/react-query";

import { featureIsEnabled } from "../../utils/features.utils";
import { getBrambleSdk } from "../client/bramble.sdk";
import { getStats2Sdk } from "../client/statsSdk";
import { BrambleTransformer } from "../utils/BrambleTransformer.class";

export const useWalletPositions = ({
  pageSize = 50,
  page = 0,
}: {
  pageSize?: number;
  page?: number;
}) => {
  const {
    details: { mainAddress },
  } = useWalletDetails();
  const queryInfo = useQuery(
    ["getWalletPositions", mainAddress, pageSize, page],
    async () => {
      if (featureIsEnabled("bramble")) {
        const { getAdaPrice } = await getStats2Sdk();
        const { fetchPositions } = await getBrambleSdk();
        const { adaPrice } = await getAdaPrice();
        const response = await fetchPositions({ address: mainAddress });
        return BrambleTransformer.transformBrambleLiquidity(
          response?.portfolio?.liquidity ?? [],
          adaPrice
        );
      }

      const { getPositions } = await getStats2Sdk();
      const data = await getPositions({
        wallet: mainAddress,
        pageSize,
        page,
      });

      return { bramble: [], stats: data?.positions?.liquidity?.liquidity ?? [] };
    },
    {
      enabled: !!mainAddress,
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return {
    isFetched: !!mainAddress && queryInfo.isFetched,
    isFetching: !!mainAddress && queryInfo.isFetching,
    isLoading: !!mainAddress && queryInfo.isLoading,
    positions: queryInfo.data ?? { bramble: [], stats: [] },
  };
};
